/* global axios */

import ApiClient from './ApiClient';

class PostSaleManagementAPI extends ApiClient {
  constructor() {
    super('post_sale_management', { accountScoped: true });
  }

  dashboard(params = {}) {
    return axios.get(`${this.baseUrl()}/post_sale_cases/dashboard`, { params });
  }

  counts() {
    return axios.get(`${this.baseUrl()}/post_sale_cases/counts`);
  }

  deeds(params = {}) {
    return axios.get(`${this.url}/deeds`, { params });
  }

  updateQueue(userId, payload) {
    return axios.patch(`${this.url}/queue/${userId}`, payload);
  }
}

export default new PostSaleManagementAPI();
